import { checkOnboardingState } from "helpers/fakebackend_helper";
import React, { useState } from "react";
import { Input, Button, Alert } from "reactstrap";
import StepCompleteActionButton from "./StepCompleteActionButton";

const EmailFormStep = ({ step, token, onNext }) => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const onClickButton = async () => {
        setError("");
        setLoading(true);

        try {
            const res = await checkOnboardingState(token, { email });

            if (res.code === 1) {
                setLoading(false);
                onNext(email, res.data);
            } else {
                setLoading(false);
                setError(res.message || "An error occurred");
            }
        } catch (e) {
            setLoading(false);
            setError(e.message || "Unexpected error. Please try again.");
        }
    };

    return (
        <>
            {/* Error Alert */}
            {error && (
                <Alert color="danger" className="text-start">
                    {error}
                </Alert>
            )}

            <h1 className="text-dark mb-4 fw-semibold">{step.step_title}</h1>
            <h6 className="text-dark mb-4" style={{ whiteSpace: "pre-line" }}>{step.step_description}</h6>

            <Input
                type="email"
                placeholder="Enter your email"
                style={{ textAlign: "center" }}
                className="mb-3"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />

            <StepCompleteActionButton
                label={loading ? "Loading..." : "START"}
                onClick={onClickButton}
                disabled={loading}
            />
        </>
    );
};

export default EmailFormStep;